import { render, staticRenderFns } from "./SubjectAvailability.vue?vue&type=template&id=16b8446d&scoped=true"
import script from "./SubjectAvailability.vue?vue&type=script&lang=js"
export * from "./SubjectAvailability.vue?vue&type=script&lang=js"
import style0 from "./SubjectAvailability.vue?vue&type=style&index=0&id=16b8446d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b8446d",
  null
  
)

export default component.exports